import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e5dac2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "history-item shadow-sm mb-2 mt-2" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = {
  key: 0,
  class: "date-time mb-2"
}
const _hoisted_4 = { class: "mr-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, "ngày", -1))
const _hoisted_6 = { class: "sub-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ngày cập nhật:", -1))
const _hoisted_8 = { class: "body p-3" }
const _hoisted_9 = { class: "attributes" }
const _hoisted_10 = { class: "display mb-1" }
const _hoisted_11 = { class: "value mb-3" }
const _hoisted_12 = { class: "display mb-1" }
const _hoisted_13 = { class: "value mb-3" }
const _hoisted_14 = { class: "display mb-1" }
const _hoisted_15 = { class: "value images" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tag3 = _resolveComponent("Tag3")!
  const _component_Avatar3 = _resolveComponent("Avatar3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.history.time)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.format(new Date(_ctx.history.time), 'kk:mm')), 1),
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(_ctx.format(new Date(_ctx.history.time), 'dd/MM/yyyy')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", null, _toDisplayString(_ctx.format(new Date(_ctx.history.updatedAt), 'dd/MM/yyyy')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history.attributes, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "attributes-item",
            key: item.key
          }, [
            (item.type ==='string' || item.type ==='number' )
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(item.display), 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(item.value), 1)
                ], 64))
              : _createCommentVNode("", true),
            (item.type ==='select')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(item.display), 1),
                  _createElementVNode("span", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value, (x, i) => {
                      return (_openBlock(), _createBlock(_component_Tag3, {
                        class: "mr-2",
                        size: "small",
                        type: "danger",
                        key: i
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(x), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (item.type ==='image')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(item.display), 1),
                  _createElementVNode("span", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value, (x, i) => {
                      return (_openBlock(), _createBlock(_component_Avatar3, {
                        class: "mr-1 mb-1",
                        width: "80px",
                        height: "80px",
                        type: "warning",
                        radius: "5px",
                        key: i,
                        avatar: x,
                        onClick: ($event: any) => (_ctx.handleViewFull(x))
                      }, null, 8, ["avatar", "onClick"]))
                    }), 128))
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}